import React, { useEffect, useRef, useState } from 'react';
import { Container, Tab, Tabs } from 'react-bootstrap';
import CreateCoupon from './CreateCoupon';
import CouponsAssigned from './CouponsAssigned';
import LoadingScreen from '../../Layout/LoadingScreen';
import { getCouponPromos } from '../../services/couponService';

const Coupons = () => {
  const [coupons, setCoupons] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    hasNextPage: false,
  });
  const isComponentMounted = useRef(false);
  const requestedPageRef = useRef(1);

  const getCoupons = async (page = 1) => {
    requestedPageRef.current = page;
    try {
      const res = await getCouponPromos(page);
      if (isComponentMounted?.current && requestedPageRef.current === page) {
        const data = res.data;
        setCoupons(Array.isArray(data) ? data : []);
        setPagination({
          currentPage: res.currentPage ?? 1,
          totalPages: res.totalPages ?? 1,
          totalRecords: res.totalRecords ?? 0,
          hasNextPage: res.hasNextPage ?? false,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      if (isComponentMounted?.current) {
        setInitialLoading(false);
      }
    }
  };

  useEffect(() => {
    isComponentMounted.current = true;
    getCoupons();
    return () => {
      isComponentMounted.current = false;
    };
  }, []);

  return (
    <>
      {initialLoading ? (
        <LoadingScreen />
      ) : (
        <Container>
          <Tabs defaultActiveKey='coupon' id='coupon-tab'>
            <Tab eventKey='coupon' title='Asignar coupon'>
              <CreateCoupon getCoupons={getCoupons} />
            </Tab>
            <Tab eventKey='profile' title='Cupones asignados'>
              <CouponsAssigned
                coupons={coupons}
                pagination={pagination}
                onPageChange={getCoupons}
              />
            </Tab>
          </Tabs>
        </Container>
      )}
    </>
  );
};

export default Coupons;